import { TranslationEntry, TranslationEntryObject } from '@app/shared/models/translatable';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import * as _ from 'lodash-es';

export enum CaseSetting {
    WORK_INSTRUCTIONS = 'WORK_INSTRUCTIONS'
}

export class CaseSettings {

    public static readonly ALL: TranslationEntry[] = [
        { key: CaseSetting.WORK_INSTRUCTIONS, trans: marker('case_setting.work_instructions') }
    ];

    public static getByKey(key: string): TranslationEntry {
        let found = _.find(CaseSettings.ALL, (type: TranslationEntry) => type.key === key);
        if (!found) {
            found = {
                key: key,
                trans: key
            } as TranslationEntry;
        }
        return found;
    }

    public static get ALL_AS_TRANSLATION_ENTRY_OBJECTS() {
        return CaseSettings.ALL.map(entry => new TranslationEntryObject(entry));
    }

    public static get WORK_INSTRUCTIONS() {
        return CaseSettings.getByKey(CaseSetting.WORK_INSTRUCTIONS);
    }
}
